<template>
  <div class="relative h-screen py-3 bg-gray-50 overflow-x-hidden overflow-y-show pl-9">
    <div class="relative pl-6 pr-3 overflow-x-hidden">
      <div class="w-full pb-6 flex items-center mb-1">
        <h2 class="pl-2 text-left w-full font-bold text-gray-900  flex items-center justify-start w-full">
          <div v-if="isBack" class="pr-3">
            <div
              class="inline-flex justify-center p-1 text-gray-500 rounded cursor-pointer hover:text-gray-900 hover:bg-gray-100   "
              @click="onBack"
            >
              <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>

          <div class="w-full text-3xl">
            {{ config?.title?.FR }}
          </div>

          <h4 class="flex justify-end ml-4 text-right font-semibold text-gray-500 items-center">
            <div class="w-48 text-gray-600 bg-gray-100 font-semibold text-center rounded-sm text-sm">
              {{ config?.subtitle?.FR }}
            </div>
          </h4>
        </h2>
      </div>

      <section class="hidden w-full bg-gray-50  mt-2">
        <div class="w-full flex items-center h-full w-full bg-orange-100">
          <WeekComponent
            class="hidden"
            :config="config"
            :records="records"
            :offset="offset"
            :limit="limit"
            :currentTab="currentTab"
            :isLoading="isLoading"
            :isLoading2="isLoading2"
            :isLoading3="isLoading3"
            :filterList="filterList"
            :results="results"
            @export="onExportClick"
            @refresh="onRefresh"
          />
        </div>
      </section>

      <section class="w-full bg-gray-50  mt-2 pr-6">
        <div class="w-full flex items-center h-full w-full">
          <FiveColComponent
            class="w-full"
            :id="getId"
            :config="config"
            :records="records"
            :offset="offset"
            :limit="limit"
            :currentTab="currentTab"
            :isLoading="isLoading"
            :isLoading2="isLoading2"
            :isLoading3="isLoading3"
            :filterList="filterList"
            :results="results"
            @export="onExportClick"
            @refresh="onRefresh"
          />
        </div>
      </section>
    </div>
  </div>
  <ExportDataModal @close="OnExportDataModalClose" @confirm="OnExportDataModalOk" :input="inputExportData" :refresh="refreshExportDataModal" />
</template>
<script>
const MAX_ITEMS = 300;
import { Modal } from "flowbite";
import service from "@/services/FullService.vue";
import { mapGetters } from "vuex";
import WeekComponent from "@/components/WeekComponent.vue";
import FiveColComponent from "@/components/FiveColComponent.vue";

import ExportDataModal from "@/components/modals/ExportDataModal.vue";
import axios from "axios";

export default {
  name: "WeekView",
  components: {
    FiveColComponent,
    WeekComponent,
    ExportDataModal,
  },

  data() {
    return {
      records: [],
      config: {
        options: {},
      },
      exportDataModal: null,
      inputExportData: null,
      filters: {},
      offset: 0,
      limit: MAX_ITEMS,
      lg: "FR",
      currentTab: 0,
      isLoading: false,
      isLoading2: false,
      isLoading3: false,
      current_page: 1,
      lastQuery: "",
      results: {
        latest: [],
        matching: [],
        suggestions: [],
        buttons: [],
      },
      filterList: [],
    };
  },
  computed: {
    ...mapGetters({ user: "StateUser" }),
    isLoggedIn: function () {
      return this.$store.getters.isAuthenticated;
    },
    isBack: function () {
      return this.$route?.query?.back || this.config?.options?.displayBack == true;
    },
    isDeveloper: function () {
      return this.user?.isDeveloper;
    },
    getId: function () {
      return this.$route?.params?.id;
    },
  },
  watch: {
    refresh: async function () {
 

      //filters['category'] = config.filters;
      this.current_page = 1;

      //        let filters = {}

      //      let val  = this.$route.params.id
      //  this.reloadPage(val, 0, MAX_ITEMS, filters, 1, this.current_page);
      window.scrollTo(0, 0);
    },
    "$route.params.id": async function (val) {
     

      //filters['category'] = config.filters;
      this.current_page = 1;

      let filters = {};

      this.reloadPage(val, 0, MAX_ITEMS, filters, 1, this.current_page);
      window.scrollTo(0, 0);
    },
    config: function (val) {
      if (val) {
        if (val.title) this.title = val.title[this.lg];
        if (val.button) this.button = val.button[this.lg];
      }
    },
    "user.tenant": async function () {
     
      this.isLoading = true;
      //let filters = {}

      // this.reloadPage(this.$route.params.id, 0, MAX_ITEMS, filters);
      window.scrollTo(0, 0);
    },
  },
  async mounted() {
    let filter = {};
    this.filters = filter;
    let page = this.current_page;
    if (this.$route.query.page != undefined) {
      page = parseInt(this.$route.query.page);
      this.current_page = page;
      if (this.current_page < 1) this.current_page = 1;
    }

    let code = null;

    if (this.$route.query.code != undefined) code = this.$route.query.code;
 
    let config = await service.getConfiguration(this.$route.params.id, code, this.user?.token);
    if (config) {
      this.config = config;
    }

    const modalElExport = document.getElementById("export-data-modal");
    this.exportDataModal = new Modal(modalElExport, {
      placement: "center",
    });
  },
  methods: {
    async onExportClick() {
      this.refreshExportDataModal = new Date().toISOString();

      let inputExportData = {
        id: "",
        type: "select-month",
        price_catalog_name: "",
        price_catalog_id: "",
        mode: "create",
        delivery_: "<en attente>",
        action: event.action,
        options: this.config.options,
        source: {
          item_id: "",
          type: "depot",
          number: "<en attente>",

          member_id: null,

          temperature: "",
          temperature_unit: "°C",
          hunter_id: "",
        },
      };

      this.inputExportData = inputExportData;

      this.exportDataModal.show();
    },
    OnExportDataModalClose: function () {
      this.exportDataModal.hide();
      this.refreshExportDataModal = null;
    },

    OnExportDataModalOk: async function (event) {
      try {
        let query = this.$route.query;

        delete query.page;
        delete query.sort;
        delete query.limit;
        delete query.tab;

        let query_url = "";

     

        if (event.type == "select-month") {
          query = {};
          query.period = event.target.period;
          query.type == event.type 
        } else {
          //  query.start_period = event.target.start_period;
          ///  query.end_period = event.target.end_period;
        }

        let keys = Object.keys(query);

        for (let i = 0; i < keys.length; i++) {
          query_url += "&" + keys[i] + "=" + query[keys[i]];
        }
        const response = await axios.get("/api/b4food/" + "data-sources/" + this.config.source_id + "/records?limit=50000" + query_url, {
          responseType: "blob", // Assure la réception d'un Blob pour les fichiers binaires
          headers: {
            "x-access-token": this.user?.token,
            accept: "application/csv",
          },
        });

        let filename = "export.xlsx"; // fallback
        const disposition = response.headers["content-disposition"];

        if (disposition && disposition.includes("filename=")) {
          const filenameMatch = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (filenameMatch != null && filenameMatch[1]) {
            filename = filenameMatch[1].replace(/['"]/g, ""); // nettoie les quotes
          }
        } else {
          const today = new Date();
          const year = today.getFullYear();
          const month = String(today.getMonth() + 1).padStart(2, "0"); // Ajouter un '0' si nécessaire
          const day = String(today.getDate()).padStart(2, "0"); // Ajouter un '0' si nécessaire
          filename = `export_${year}-${month}-${day}.xlsx`;
        }

        // Convertir la réponse en Blob pour en faire un fichier téléchargeable
        const url = window.URL.createObjectURL(new Blob([response.data]));

        // Création et déclenchement du téléchargement
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();

        // Suppression de l'URL et du lien pour libérer la mémoire
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        console.log(e);
      }

      this.exportDataModal.hide();
      this.refreshExportDataModal = null;
    },

    onRefresh(period) {
      this.reloadPage(this.$route.params.id, 0, MAX_ITEMS, period.filter, 1, this.current_page);
    },
    async reloadPage(id, offset, limit, filter, level, page) {
      if (level == null) level = 1;
      if (this.user == undefined) {
        //                    this.$router.push("/login");
        window.location = "/login";
        return;
      }

      this.current_page = page;

      let loffset = parseInt((page - 1) * limit);

      if (loffset == undefined) loffset = 0;

      this.limit = limit;

      //  if (level == 1) this.isLoading = true;
      if (level == 2) this.isLoading2 = true;
      if (level == 3) this.isLoading3 = true;

      let code = null;

      if (this.$route.query.code != undefined) code = this.$route.query.code;
      //  console.log("TableView " + code)
      let config = await service.getConfiguration(id, code, this.user?.token);

      if (config == undefined) {
        return;
      }

      //TODO Remove this, tabs must be delivered via Backoffice

      if (config.tabs == undefined) {
        let t = await service.getFilterTabDefinition(this.$route.params.id, this.user?.token, { template: this.$route.params.id });
        {
          //TODO Check how to remove this
          if (
            this.$route.params.id == "suppliers" ||
            this.$route.params.id == "products" ||
            this.$route.params.id == "raw-products" ||
            this.$route.params.id == "suppliers-product" ||
            this.$route.params.id == "manufacturing-orders" ||
            this.$route.params.id == "data-errors"
          ) {
            if (this.$route.query.tab == undefined) if (t.records && t.records[0]) filter.category = t.records[0].id;
          }
          if (t) {
            config.tabs = t.records;
          }
        }
      }

      if (config?.search?.buttons != undefined) {
        if (filter.category != undefined) {
          let buttons = config.search.buttons[filter.category];
          if (buttons != undefined) {
            this.results.buttons = buttons;
          } else {
            this.results.buttons = [];
          }
        } else {
          let buttons = config.search.buttons["*"];
          if (buttons != undefined) {
            this.results.buttons = buttons;
          } else {
            this.results.buttons = [];
          }
        }
      } else {
        this.results.buttons = [];
      }

      this.filter = filter;

      let filterBarFilter = {};
      if (this.$route.query.category != undefined) {
        filterBarFilter.category = this.$route.query.category;
      }

      let d = await service.getFilterBarDefinition(this.$route.params.id, this.user?.token, filterBarFilter);

      config.secondBar = d.records;

      for (let i = 0; i < config.secondBar.length; i++) {
        if (config.secondBar[i].data == "supplier_id") {
          if (filter["supplier_id"] != undefined) {
            config.secondBar[i].selected = filter["supplier_id"];

            if (filter["supplier_id"] == "*") {
              delete filter["supplier_id"];
            }
          } else config.secondBar[i].selected = "*";
        }

        if (config.secondBar[i].data == "item_organic") {
          if (filter["item_organic"] != undefined) {
            config.secondBar[i].selected = filter["item_organic"];

            if (filter["item_organic"] == "*") {
              delete filter["item_organic"];
            }
          } else config.secondBar[i].selected = "*";
        }

        if (config.secondBar[i].data == "entity_id") {
          if (filter["entity_id"] != undefined) {
            config.secondBar[i].selected = filter["entity_id"];

            if (filter["entity_id"] == "*") {
              delete filter["entity_id"];
            }
          } else config.secondBar[i].selected = "*";
        }

        if (config.secondBar[i].data == "location_id") {
          if (filter["location_id"] != undefined) {
            config.secondBar[i].selected = filter["location_id"];

            if (filter["location_id"] == "*") {
              delete filter["location_id"];
            }
          } else config.secondBar[i].selected = "*";
        }
        if (config.secondBar[i].data == "supplier_type") {
          if (filter["supplier_type"] != undefined) {
            config.secondBar[i].selected = filter["supplier_type"];

            if (filter["supplier_type"] == "*") {
              delete filter["supplier_type"];
            }
          } else config.secondBar[i].selected = "*";
        }
      }

      if (config.tabs != undefined) {
        if (config.tabs.length > 0) {
          if (this.currentTab == undefined) this.currentTab = 0;
          filter = { ...filter, ...config.tabs[this.currentTab].filter };
        }
      }

      this.config = config;

      // this.records = await service.getData(id, this.user?.token, Object.assign({}, { limit: limit, offset: offset }, filter))

      let query = Object.assign({}, filter);

      if (query == undefined) query = {};

      query["page"] = page;

      this.$router.replace({ path: this.$route.path, query: query });

      this.records = await service.getData("data-sources/" + config.source_id + "/records", this.user?.token, Object.assign({}, { limit: limit, offset: loffset }, filter));

      if (level == 1) this.isLoading = false;
      if (level == 2) this.isLoading2 = false;
      if (level == 3) this.isLoading3 = false;
      this.filters = filter;
    },
  },
};
</script>
